export default __webpack_public_path__ + "static/media/instagram.c92359d7.svg";